import { Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import twttr from 'twitter-text';

@Component({
  selector: 'app-message-content',
  template: '',
  styleUrls: ['./message-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageContentComponent implements OnInit {
  @Input() input: any;
  element: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.element = this.el.nativeElement;

    const urlYoutubeMatched = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/; // eslint-disable-line no-useless-escape
    const entities = twttr
      .extractUrlsWithIndices(this.input)
      .concat(twttr.extractMentionsOrListsWithIndices(this.input))
      .concat(twttr.extractHashtagsWithIndices(this.input, { checkUrlOverlap: false }));
    if (entities.length > 1) {
      twttr.removeOverlappingEntities(entities);
    }
    const inputBlocksArray = this.createInputBlocksArray(this.input, entities);
    for (const inputBlock of inputBlocksArray) {
      if (inputBlock.text) {
        const newElement = this.renderer.createElement('span');
        this.renderer.setProperty(newElement, 'textContent', inputBlock.text);
        this.renderer.appendChild(this.element, newElement);
      } else if (inputBlock.url) {
        const newElement = this.renderer.createElement('a');
        this.renderer.setProperty(newElement, 'textContent', inputBlock.url);
        this.renderer.setAttribute(newElement, 'href', inputBlock.url);
        this.renderer.setAttribute(newElement, 'rel', 'noopener noreferrer');
        this.renderer.setAttribute(newElement, 'target', '_blank');

        this.renderer.appendChild(this.element, newElement);
      } else if (inputBlock.screenName) {
        const newElement = this.renderer.createElement('span');
        this.renderer.setProperty(newElement, 'textContent', `@${inputBlock.screenName}`);
        this.renderer.addClass(newElement, 'message-entity');

        this.renderer.appendChild(this.element, newElement);
      } else if (inputBlock.hashtag) {
        const newElement = this.renderer.createElement('span');
        this.renderer.setProperty(newElement, 'textContent', `#${inputBlock.hashtag}`);
        this.renderer.addClass(newElement, 'message-entity');

        this.renderer.appendChild(this.element, newElement);
      }
    }
    this.createYoutubeEmbeddedArray(entities, urlYoutubeMatched);
  }

  private createInputBlocksArray(input, entities) {
    const inputBlocksArray = [];
    let lastEndPosition = 0;
    for (const entity of entities) {
      //Text before the url
      const text = input.slice(lastEndPosition, entity.indices[0]);
      if (text.length > 0) {
        inputBlocksArray.push({ text });
      }
      inputBlocksArray.push(entity);
      lastEndPosition = entity.indices[1];
    }
    //last string at the end
    if (input.length > lastEndPosition) {
      const text = input.slice(lastEndPosition, input.length);
      if (text.length > 0) {
        inputBlocksArray.push({ text });
      }
    }
    return inputBlocksArray;
  }

  private createYoutubeEmbeddedArray(entities, urlYoutubeMatched) {
    for (const entity of entities) {
      if (entity.url) {
        const youtubeMatch = entity.url.match(urlYoutubeMatched);
        if (youtubeMatch && youtubeMatch[2].length === 11) {
          const youtubeUrl = `https://www.youtube.com/embed/${youtubeMatch[2]}`;

          const newBRElement = this.renderer.createElement('br');
          this.renderer.appendChild(this.element, newBRElement);

          const newYoutubeElement = this.renderer.createElement('iframe');
          this.renderer.addClass(newYoutubeElement, 'video-container');
          this.renderer.setAttribute(newYoutubeElement, 'src', youtubeUrl);
          this.renderer.setAttribute(newYoutubeElement, 'frameborder', '0');
          this.renderer.setAttribute(newYoutubeElement, 'allow', 'fullscreen');

          this.renderer.appendChild(this.element, newYoutubeElement);
        }
      }
    }
  }
}
